import avatarModule from '../avatarModule';

function outfitNameModalController($scope, $uibModalInstance, $log, modalData) {
  'ngInject';

  $scope.params = modalData;
  $scope.submit = () => {
    const result = {
      outfitName: $scope.outfitName
    };
    $uibModalInstance.close(result);
  };

  $scope.close = () => {
    $uibModalInstance.dismiss();
  };
}

avatarModule.controller('outfitNameModalController', outfitNameModalController);

export default outfitNameModalController;
